import React from "react";
import Hammer from "../../Shared/SvgIcons/Hammer";

const Bid = () => {
  return (
    <div className="flex w-1/5 flex-col items-center justify-center gap-4 border-l border-lightGray">
      <div>
        <span className="font-pop text-xl font-bold text-darkGreen">
          R 299,999
        </span>
        <span className="font-pop text-sm font-bold text-darkGreen">.00</span>
      </div>
      <Hammer className="h-8 w-8" />
      <span className="font-pop text-xs font-medium underline">8 bid(s)</span>
      <button className="rounded-lg bg-primary px-8 py-2.5 text-white">
        View
      </button>
      <p className="text-center font-pop text-xs font-medium leading-5 text-primary">
        Remaining Time <br />1 Day 18:44:05
      </p>
    </div>
  );
};

export default Bid;
